import React, { useState } from 'react';

import { MenuItem } from '@mui/material';
import Divider from '@mui/material/Divider';
import { useHistory } from 'react-router-dom';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { Segment, useQueryGetSegmentsList } from 'api/queries/getSegmentsList.query';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/components/ActivitiesSegments/ActivitiesSegments.module.scss';
import { ConfirmDeleteSegment } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/components/ActivitiesSegments/components/ConfirmDeleteSegment/ConfirmDeleteSegment';
import { Button } from 'components/DesignSystem/Button';
import { CustomizedDropdownMenu, CustomizedTooltip } from 'components/common';

import { SaveSegment } from './components/SaveSegment/SaveSegment';

export const ActivitiesSegments = () => {
    const { contract } = useProjectTreeStore();
    const { version } = useVersionStore();
    const [segment, setSegment] = useState<Segment | null>(null);
    const [showModal, setShowModal] = React.useState(false);
    const { data: segments } = useQueryGetSegmentsList({ metaDataId: version?.id, contractId: contract?.id });
    const history = useHistory();

    const handleSelectSegment = (segment: Segment) => {
        history.push(segment.url);
    };

    return (
        <>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`Manage Segments`}
                        triggerElement={
                            <Button
                                data-testid={'activities-segments'}
                                endIcon={
                                    <Icon
                                        name={'header-arrow-down'}
                                        size={'1.5rem'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                startIcon={
                                    <MuiIcon
                                        icon={'filter_list'}
                                        fontSize={'1.5rem'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                variant={'secondary'}
                            >
                                Activities Segments
                            </Button>
                        }
                    />
                }
            >
                <MenuItem className={classes.item} onClick={() => setShowModal(true)}>
                    Save Segment
                </MenuItem>
                {segments && segments?.length > 0 && <Divider />}
                {segments?.map((item) => (
                    <MenuItem key={item.segmentId} className={classes.item} onClick={() => handleSelectSegment(item)}>
                        {item.name}{' '}
                        <div
                            className={classes.icon}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSegment(item);
                            }}
                        >
                            <MuiIcon icon={'close_small'} color={'#cc0000'} />
                        </div>
                    </MenuItem>
                ))}
            </CustomizedDropdownMenu>

            <SaveSegment isShowModal={showModal} handleModalClose={() => setShowModal(false)} />

            <ConfirmDeleteSegment segment={segment} handleModalClose={() => setSegment(null)} />
        </>
    );
};
